import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { useCandidateDashboardContext } from '@common/context/candidateDashboardContext';

const Styled = {
  Background: styled(Box)({
    backgroundColor: 'transparent'
  }),
  Root: styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    padding: '0.5em 0 0.5em 5em',
    ['@media (max-width:1100px)']: {
      padding: '0.5em',
    }
  }),
  PageHeaderTitle: styled(Typography)(({ theme }) => ({
    fontSize: '3rem',
    lineHeight: '1.5em',
    color: theme.palette.GOLD_1.main,
    marginBottom: '0',
    paddingBottom: '0.5em',
  }))
};

const WelcomeSection: React.FC = () => {
  const { candidateProfile, loaded } = useCandidateDashboardContext();

  return (
    <Styled.Background data-testid="welcome-section-root">
      <Styled.Root>
        {loaded && candidateProfile && (
          <Styled.PageHeaderTitle variant="EC_TYPE_3XL" data-testid="dashboard-page-title">
            WELCOME, {candidateProfile.firstName.toUpperCase()}!
          </Styled.PageHeaderTitle>
        )}
      </Styled.Root>
    </Styled.Background>
  );
};

export default WelcomeSection;
